import { APP_SAGA_GET_PAYROLL_PERIODS } from '../actionTypes'

export const getPayrollPeriods = () => ({ type: APP_SAGA_GET_PAYROLL_PERIODS })
